import React from 'react';
import { useParams } from 'react-router-dom';
import EditUserLayer from '../components/EditUserLayer';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';

const EditUserPage = () => {
  const { id } = useParams();

  return (
      <EditUserLayer userId={id} />
  );
};

export default EditUserPage;
